<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick" @row-dblclick="handleDbclick">
            <template v-slot:col-append="{ col, row }">
                <div v-if="col.prop === 'mipUrl'">
                    <span size="mini" type="text" class="mip-page-link no-wrap" :title="row.mipUrl"
                        @click="handleLink(row)">{{ row.mipUrl || '' }}</span>
                </div>
                <div v-else-if="col.prop === 'customerChangeCode'">
                    <span size="mini" type="text" class="mip-page-link no-wrap" :title="row.customerChangeCode"
                        @click="handleLink(row)">{{ row.customerChangeCode || '' }}</span>
                </div>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getCustomerPage } from '@mdm/api/customer/customerManage.js';
import { ref, watch, computed, reactive, getCurrentInstance } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
import bigDataLog from '@/utils/bigDataLog.js';

export default {
    components: {
        lotsPagination, tableBox
    },
    emits: [''],
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        class IflowTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.dynamicOptQuery = {};
                condition.dynamicOptQuery.belongCustomerCode = {
                    operator:
                        'CONTAINS',
                    values:
                        [props.detailData.customerCode]
                };
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list;
                    subTabTable.pageTotal.value = res.data.totalCount;
                }
            }
        };
        const subTabTable = new IflowTalbeClass({
            Api: {
                listApi: getCustomerPage
            }
        });
        const handleLink = (row) => {
            handleDbclick(row);
        };
        const dictData = ref({});
        watch(
            () => [props.activeName, props.detailData, props.detailData.contractChangeCode],
            (newVal, oldVal) => {
                if (newVal[0] === 'virtual' && newVal[1].customerCode) {
                    subTabTable.getList();
                } else if (!newVal[1].customerCode) {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            }
        );

        const actionClick = (event, row) => {

        };
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const handleDbclick = (row) => {
            // const _name = row.customerChangeType?.toString() === '1' ? 'customerApplyFlow' : 'customerChangeFlow';
            // const _query = {
            //     customerChangeCode: row.customerChangeCode
            // };
            // if (row.customerChangeType?.toString() === '1') {
            //     _query.customerCode = row.customerCode;
            // }
            // emit 状态当前虚拟客户详情
            setupContext.emit('db-click-open', row);
            ctx.$router.replace({ path: '/mod/mdm/customer-manage', query: { customerCode: row.customerCode } });
            bigDataLog.sendDetailMessageByKey('bigData-page-customer-detail');
        };
        return {
            config,
            TABLECONFIG,
            dictData,
            subTabTable,
            handleLink,
            actionClick,
            handleDbclick
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {

    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link {
        color: #4285f5;
        cursor: pointer;

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
